import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { StorageService } from '../../../core/storage/storageService' ;
import { UserProfileDialogComponent } from '../../user-profile/user-profile-dialog/user-profile-dialog.component';

@Component({
  selector: 'app-profile-button',
  templateUrl: './profile-button.component.html',
  standalone: false,
})
export class ProfileButtonComponent implements OnDestroy {
  myInitial = '';
  myName = '';

  userSubscription: Subscription | undefined = undefined;
  userProfileDialogRef: Subscription | undefined = undefined;

  constructor(
    private storage: StorageService,
    public contactDialog: MatDialog,
  ) {
    this.refreshProfile();
  }

  ngOnInit() {
    this.userSubscription = this.storage
      .watchCurrentUserChange()
      .subscribe((changed: string) => {
        this.refreshProfile();
      });
  }

  ngOnDestroy(): void {
    this.userSubscription?.unsubscribe();
    this.userProfileDialogRef?.unsubscribe();
  }

  private refreshProfile() {
    try {
      let user = this.storage.getCurrentUser();

      if (user != null) {
        this.myInitial = user.firstName[0] + '' + user.lastName[0];
        this.myName = user.firstName + ' ' + user.lastName;
      } else {
        this.myInitial = '';
        this.myName = '';
      }
    } catch {
      this.myInitial = '';
      this.myName = '';
    }
  }

  clickProfile() {
    // TODO: Re-enable this when we have a user profile to show
    // const dialogRef = this.contactDialog.open(UserProfileDialogComponent, {
    //   minWidth: "600px",
    //   maxWidth: "80vw",
    //   data: {
    //   }
    // });
    // this.userProfileDialogRef = dialogRef.afterClosed()
    // .subscribe(result => {
    // });
  }
}
